import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { Button } from '../../../../../button/esm';

var styles = {"field":"table__field_8zspi","open":"table__open_8zspi"};
require('./index.css');

var CustomSelectField = function (_a) {
    var _b;
    var selected = _a.selected, innerProps = _a.innerProps, Arrow = _a.Arrow, open = _a.open;
    var ref = innerProps.ref, restInnerProps = __rest(innerProps, ["ref"]);
    return (React.createElement("div", { ref: ref },
        React.createElement(Button, __assign({}, restInnerProps, { size: 'xxs', view: 'link', className: cn(styles.field, (_b = {}, _b[styles.open] = open, _b)), rightAddons: Arrow }), selected === null || selected === void 0 ? void 0 : selected.content)));
};

export { CustomSelectField };
